import { render, staticRenderFns } from "./OriginatorRestriction.vue?vue&type=template&id=0ff58f2c&"
import script from "./OriginatorRestriction.vue?vue&type=script&lang=ts&"
export * from "./OriginatorRestriction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports